import { PRICE_EUR, STORE_CONNECTED } from '@/core/paywall'
import { useSettings } from './settings'

/**
 * Die Kaufschranke.
 *
 * Sie sagt, was gratis ist und was nicht, und schaltet frei. Einen Zahlvorgang gibt es
 * hier nicht: den führt der Store, und die Anbindung kommt mit der Hülle. Bis dahin ist
 * der Knopf ehrlich beschriftet und merkt sich den Kauf auf dem Gerät.
 */
export function Paywall() {
  const { t, settings, update, lang } = useSettings()
  // Im Deutschen das Komma, im Englischen der Punkt.
  const price = lang === 'de' ? PRICE_EUR.toFixed(2).replace('.', ',') : PRICE_EUR.toFixed(2)

  return (
    <section className="paywall" data-testid="paywall">
      <h2>{t('paywall.title')}</h2>
      <p className="detail__text">{t('paywall.body')}</p>
      <p className="detail__text">
        {t('paywall.price', { price })}
      </p>
      {!STORE_CONNECTED && (
        <p className="signal__legend" data-testid="paywall-stub">
          {t('paywall.stub')}
        </p>
      )}
      {settings.unlocked ? (
        <p className="detail__text" data-testid="paywall-unlocked">
          {t('paywall.unlocked')}
        </p>
      ) : (
        <button
          type="button"
          className="signal__play"
          data-testid="paywall-buy"
          onClick={() => update({ unlocked: true })}
        >
          {t('paywall.buy')}
        </button>
      )}
    </section>
  )
}
